import React, { Fragment, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import _ from "lodash";

import { SpeedDial, SpeedDialAction } from "@material-ui/lab";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";

import AppBar from "components/AppBar/AppBar";

import "./Frame.css";

const defaultComponent = Fragment;
const defaultIcon = Fragment;
export const defaultScreens = [
  {
    label: `Default`,
    component: defaultComponent,
    icon: defaultIcon,
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
  },
}));

const selectScreens = createSelector(
  (state) => state?.UI?.screens ?? defaultScreens,
  _.identity
);

export const dataTestid = "frame";
const Frame = () => {
  const classes = useStyles();
  const appFrame = useRef(null);
  const [activeScreenIndex, setActiveScreenIndex] = useState(0);
  const [speedDialOpen, setSpeedDialOpen] = useState(false);

  const UIscreens = useSelector(selectScreens);

  const onScreenChange = (evt, activeScreenIndex) => {
    setActiveScreenIndex(activeScreenIndex);
  };
  const onSpeedDialClose = () => {
    setSpeedDialOpen(false);
  };
  const onSpeedDialOpen = () => {
    setSpeedDialOpen(true);
  };

  useEffect(() => {
    setActiveScreenIndex(0);
  }, [UIscreens]);

  const { component: Screen } = _.get(
    UIscreens,
    activeScreenIndex,
    defaultComponent
  );

  return (
    <div
      data-testid={dataTestid}
      className={clsx("wsh-AppFrame", classes.root)}
      ref={appFrame}
      onClick={onSpeedDialClose}
    >
      <AppBar />
      <div className="wsh-AppScreen">
        <Screen closeSpeedDial={onSpeedDialClose} />
        {UIscreens.length > 1 && (
          <SpeedDial
            style={{
              position: `fixed`,
              whiteSpace: `nowrap`,
              bottom: `0`,
              marginBottom: `21px`,
              right: `16px`,
            }}
            data-testid="speeddial"
            ariaLabel="Menu"
            icon={<MoreVertIcon />}
            onClose={onSpeedDialClose}
            onOpen={onSpeedDialOpen}
            open={speedDialOpen}
            direction="up"
            onClick={(evt) => evt.stopPropagation()}
          >
            {UIscreens.map((screen, index) => {
              const { label, icon: Icon } = screen;
              return (
                <SpeedDialAction
                  data-testid="speeddial-action"
                  key={label}
                  icon={<Icon />}
                  tooltipTitle={label}
                  tooltipPlacement="left"
                  tooltipOpen
                  onClick={(evt) => {
                    onScreenChange(evt, index);
                    onSpeedDialClose();
                  }}
                />
              );
            })}
          </SpeedDial>
        )}
      </div>
    </div>
  );
};

export default Frame;
